module.exports = __webpack_public_path__ + "static/media/video-meet-mobile.88bcb048.svg";